import { apiRequest } from "../../api";
export const root = "/loyalty/admin";
export async function request(path, method = "GET", data) {
  const response = await apiRequest({
    path,
    method,
    data,
  });
  if (!response || response.error) {
    throw new Error(response?.error_description || "Unable to load rewards");
  }
  return response;
}
